import React from 'react'
import BudgetDriverCheckboxGroup from './BudgetDriverCheckboxGroup'

interface CtxBudgetDriverCheckboxGroupProps {
  value?: number[]
  onChange?: (values: number[]) => void
  placeholder?: string
  checkOnSearch?: boolean
}

const CtxBudgetDriverCheckboxGroup: React.FC<CtxBudgetDriverCheckboxGroupProps> = props => {
  return <BudgetDriverCheckboxGroup {...props} />
}

export default CtxBudgetDriverCheckboxGroup
